import { IInspectionPointFormValues } from './inspectionPointFormValues';
import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';

/**
 * Zod schema for validating inspection point data.
 * Extends the base model schema with inspection point-specific fields.
 * Represents a quality control checkpoint in the system.
 *
 * @property {string} code - Unique identifier code (max 5 characters)
 * @property {string} name - Name of the inspection point (max 255 characters)
 * @property {string} [bookingReferenceNumber] - Optional booking reference number
 */
export const inspectionPointSchema = baseModelSchema.extend({
    code: z.string().nonempty('Code is required').max(5, 'Code can only be up to 5 characters long.').default(''),
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.').default(''),
    bookingReferenceNumber: z.string().optional(),
});

/**
 * TypeScript interface representing an InspectionPoint object.
 * Generated from the Zod schema for type safety.
 */
export type IInspectionPoint = z.infer<typeof inspectionPointSchema>;

/**
 * Creates a validated InspectionPoint object from form values.
 *
 * @param {IInspectionPointFormValues} formValues - The form data to convert
 * @returns {IInspectionPoint} A validated inspection point object
 * @throws {ZodError} If validation fails
 */
export function InspectionPoint(formValues : IInspectionPointFormValues) : IInspectionPoint {
    return inspectionPointSchema.parse({
        ...formValues,
    });
}
